<template>
  <v-container>
    <v-row no-gutters :class="$root.$i18n.locale != 'ar' ? 'rtlStyle' : '' " v-if="uploadedBook">
      <v-col cols="12" md="3">
        <p class="bookNameStyle">{{versionInfo.bookname}}</p>
        <v-card
          style="overflow: auto; border: 1px solid #b5b5b5"
          class="treeviewChaptar pa-2 ml-3 mt-3"
          elevation="3"
          :height="heghtScreen + 125"
        >
          <v-treeview
            class="treeview treeviewChaptar"
            hoverable
            item-children="subitems"
            :items="Book.chapter"
            item-key="id"
            rounded
          >
            <template v-slot:prepend="{ item, open }">
              <v-icon
                color="#8bc34a"
                class="mr-2 ml-2 iconChapter"
                v-if="item.subitems != 0 && item.subitems != undefined"
              >
                {{ open ? "mdi-folder-open" : "mdi-folder" }}
              </v-icon>

              <v-icon class="mr-2 ml-2 iconChapter" color="#e19090" v-else>
                {{ (open = "mdi-file-document-outline") }}
              </v-icon>
              <a
                class="chapterLink labelChapter"
                v-if="!(item.subitems != 0 && item.subitems != undefined)"
                @click="returnHref(item)"
                >{{ item.label }}</a
              >
              <span class="labelChapter" v-else>{{ item.label }}</span>
            </template>
          </v-treeview>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <v-row>
          <v-col cols="12" md="8" class="searchSection pb-0">
            <template>
              <v-text-field
                :hide-details="true"
                class="rounded-0 magnifyIcon mb-2"
                outlined
                dense
                :label="$t('readBook.SearchInThisBook')"
                background-color="#fff"
                append-outer-icon="mdi-magnify"
                @click:append-outer="searchInBook()"
                v-model="searckInBookKey"
                @keyup.enter="searchInBook()"
              >
                <template v-slot:prepend>
                  <v-menu rig offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="height: 40px"
                        elevation="0"
                        v-bind="attrs"
                        v-on="on"
                        color="orange"
                        class="white--text rounded-0 ma-0 pa-0"
                      >
                        <v-icon left> mdi-chevron-down </v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </template>
              </v-text-field>
            </template>
          </v-col>
          <v-col cols="6" md="2" class="pb-0"
            ><v-btn 
              small 
              outlined
              style="height: 38px ; font-size: 11px;" 
              :disabled="!versionInfo.isdownloadable" 
              @click="DownloadBook(versionInfo)"
              color="#8bc34a"
            >{{$t('readBook.downloadBook')}}</v-btn>
            </v-col
          >
          <v-col v-if="versionInfo.booklink != null" cols="6" md="2" class="pb-0"
            ><v-btn color="primary" class="mx-2" @click="openPDFBook" small style="height: 38px">
              <span v-text="!opendPDD ?  $t('readBook.openPDF'): $t('readBook.colsePDF') "></span>
              </v-btn></v-col
          >
          <v-col v-if="reloaded"  :md="(versionInfo.booklink && !opendPDD ) || (!versionInfo.booklink )  ? 12 : 6" cols="12">
            <v-card
              
              ref="viewer"
              class="pa-2"
              style="border: 1px solid #b3b3b3; overflow: auto"
              :height="heghtScreen"
            >
              <div id="viewer" class="spreads"></div>
            </v-card>
            <div class="btmContainer">
              <v-row no-gutters>
                <v-col cols="12" class="mb-0 pb-0">
                  {{pagesListCount}} / {{itemsSlider.val}}
                  <v-slider 
                    v-model="itemsSlider.val"
                    :max="pagesListCount"
                    color="#8bc34a"
                    thumb-label
                    hide-details="" 
                    @change="ChangePage"
                   ></v-slider>
                </v-col
                >
                <v-col cols="4" class="pa-0 ma-0 pl-2">
                  <v-btn
                    width="100%"
                    small
                    color="primary"
                    class="arrow ma-2 mr-0"
                    @click="prevPage()"
                  >
                    <span class="fas fa-xl ml-2 fa-arrow-circle-right"> </span> {{$t('readBook.prev')}}
                  </v-btn>
                </v-col>

                
                <v-col cols="4" class="pa-0 ma-0">
                  <p style="" class="paginatClass">
                    <span style="border-radius: 6px 0px 0px 6px">{{
                      itemsSlider.val
                    }}</span>
                    <span style="border-radius: 0px 6px 6px 0px">{{
                      pagesListCount
                    }}</span>
                  </p>
                </v-col>

                <v-col cols="4" class="pa-0 ma-0">
                  <v-btn
                    width="100%"
                    small
                    color="primary"
                    class="arrow mt-2"
                    @click="nextPage()"
                  >{{$t('readBook.next')}}
                    <span class="fas fa-xl fa-arrow-circle-left mr-2"></span>
                    
                  </v-btn>
                </v-col>
                
              </v-row>
            </div>
          </v-col>
          <v-col :md="versionInfo.booklink && opendPDD  ? 6 : 12" cols="12" v-if="versionInfo.booklink  != null && opendPDD"  >
            <v-card
              ref="viewer"
              class="pa-2"
              style="border: 1px solid #b3b3b3; overflow: auto"
              :height="heghtScreen"
            >
              <div v-html="versionInfo.booklink">
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card class="pa-2" elevation="0" v-else>
      <v-skeleton-loader
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<style>
.chapterLink {
  color: blue;
  text-decoration: none;
  font-weight: 400;
}
.bookNameStyle{
  border: 1px solid #b5b5b5;
  margin: 12px 10px 15px 10px;
  background: white;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  font-size: 12px;
}
.rtlStyle {
  /* direction: rtl; */
}
.rtlStyle .treeviewChaptar{
  /* border: 1px solid #aaa; */
  margin-right: 10px;
}
.rtlStyle .treeviewChaptar .v-treeview-node__prepend .v-icon{
  float: left;
}
.rtlStyle .v-treeview-node__content{
  margin-left: -3px !important;
}
.rtlStyle .btmContainer{
  direction: rtl;
}

.labelChapter {
  width: calc(100% - 40px);
  display: flex;
  float: left;
  position: relative;
  font: status-bar;
  line-height: 23px;
  font-size: 14px;
}
.treeview .v-treeview-node.v-treeview-node--rounded .v-treeview-node__root {
  min-height: 23px;
}
.calibre {
  /* padding-right: 36px !important; */
  padding: 0 !important;
}

.treeviewChaptar .v-treeview-node__content {
  margin-right: -5px !important;
}
.treeviewChaptar .v-treeview-node__toggle {
  width: 15px;
  width: 15px;
}
.searchSection
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
  .v-input__prepend-outer {
  margin: 0;
}
.paginatClass {
  text-align: center;
  margin-top: 14px;
  font-size: 12px;
}
.paginatClass span {
  border: 2px solid #d7d7d7;
  padding: 4px;
  margin: -1px;
}
.epub-container{
  overflow: hidden !important
}
iframe{
  width: 100% !important
}
</style>
<script>
import Book from "epubjs";
import axios from "axios";
export default {
  data() {
    return {
      opendPDD : false ,
      reloaded : true ,
      searckInBookKey : '' ,
      heghtScreen : '' ,
      itemsSlider: {val: 1,  color: 'primary' } ,
      bookIframe : `<iframe src="https://drive.google.com/file/d/1LYamRXhjsEnaXlsGoqnzDihX_n5TfPuu/preview" height="465" allow="autoplay"></iframe>` ,
      Book: {
        BookObj: null,
        rendition: null,
        url: "",
        chapter: [],
        versionInfo: "",
      },
      hrefLink: "",
      indexPage: 0,
      uploadedBook: false,
      pagesList : [] ,
      pagesListCount : 0 
    };
  },
  computed: {},
  watch: {
    hrefLink: function (val) {
      this.Book.rendition.display(val);
    },
    pagesList: function(val) {
      this.pagesListCount = val.length
      if(this.$route.query.page){
         this.itemsSlider.val = this.pagesList.findIndex(i => i.href === this.$route.query.page) +1 
      }
    }
   
  },
  mounted() {
    this.getVersionInfo();
    this.heghtScreen = document.documentElement.clientHeight - 227   

  },
  methods: {
    ChangePage(){
      this.Book.rendition.display(this.pagesList[this.itemsSlider.val]['href'])
    },  
    searchInBook(){
      if(this.searckInBookKey.length < 4){
        this.$store.dispatch("PushErrorMsg", this.$t('valid.fourChar'))
        return
      }
      this.$router.push({
      name: "SearchBookInside",
      query: { kay: this.searckInBookKey , book_id : this.$route.params.bookID}// 555555
    });
    },
    getVersionInfo() {
      this.$store
        .dispatch("GetFromAPI", "/guest/book/" + this.$route.params.bookID)
        .then((response) => {
          this.versionInfo = response.data.data;
          this.Book.url = this.versionInfo.fileurl;
          this.getBook();
        })
        .catch((error) => {
          this.$store.dispatch("PushErrorMsg", error.data.data);
          this.uploadedBook = true;
        });
    },
    getBook() {
      this.Book.BookObj = new Book(this.Book.url);

      this.Book.rendition = this.Book.BookObj.renderTo("viewer", {
        flow: "scrolled-doc",
        width: "100%",
        spread: "always",
        minSpreadWidth: "100%",
        
      });

      this.Book.rendition.display();
      this.Book.rendition.themes.default({"p": { "font-size": "20px !important"}, ".span_micro" :{ "color": "orange" }, ".a_micro" :{ "text-decoration": "none" }, ".calibre" :{ "padding": "0 5px !important" }}  )
     
      this.Book.BookObj.loaded.navigation.then((nav) => {
        this.uploadedBook = true;
        this.Book.chapter = nav.toc;
      });
      this.Book.BookObj.loaded.resources.then((list) => {
        this.pagesList = list.resources
      });
      this.Book.rendition.hooks.content.register(this.UpdateBookContent);

      if(this.$route.query.page){
        this.Book.rendition.display(this.$route.query.page)
      }

      this.$nextTick(() =>{
        this.reloaded = true
      })
      


    },
    UpdateBookContent (contents){
      this.loadingAdd = true;
      let DataForm = {
          Param: {
            bookID: this.$route.params.bookID,
            versionID: this.$route.params.versionID,
            HTMLcontent: contents.content.innerHTML,
          },
          API: "/admin/microprocess",
        };
      this.$store
          .dispatch("PostToAPI", DataForm)
          .then((response) => {
            this.loadingAdd = false;
            if (response.data.success == true){
              contents.content.innerHTML = response.data.data.HTMLcontent
            }
          })
          .catch(() => {
            this.loadingAdd = false;
          });
    },
    nextPage() {
     
      // console.log(this.pagesList)
     this.Book.rendition.next();
      
     this.itemsSlider.val = this.pagesList.findIndex(i => i.href === this.Book.BookObj.rendition.location.start.href) +1 
      this.$nextTick(() => {
        this.$refs.viewer.$el.scrollTop = 0;
        // console.log(this.Book.rendition.location.start.index)
      });
    },
    prevPage() {
      this.Book.rendition.prev();
      this.itemsSlider.val = this.pagesList.findIndex(i => i.href === this.Book.BookObj.rendition.location.start.href) - 1
      this.$nextTick(() => {
        this.$refs.viewer.$el.scrollTop = 0;
        // console.log(this.Book.rendition.location.end.index)
      });
    },
    returnHref(val) {
      this.itemsSlider.val = this.pagesList.findIndex(i => i.href === val.href)
      this.hrefLink = val.href;
    },
    DownloadBook(selectedBookFromList){

      // console.log(selectedBookFromList)
      // // return

      axios({
        url: selectedBookFromList.fileurl,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        let DataForm = {
          API : `/guest/book/${selectedBookFromList.bookid}/download`
        }
        this.$store.dispatch("PostToAPI", DataForm)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", selectedBookFromList.bookname + ".epub");
        document.body.appendChild(link);
        link.click();
      });


      // window.open(this.versionInfo.fileurl)
    },
    openPDFBook(){
      this.reloaded = false ,
      this.opendPDD = !this.opendPDD
      this.getVersionInfo()
    }
  },
};
</script>